<template>
<div class="SponsorInfo">
    <p class="tips_text">小贴士：提前设置相关信息有助于提高图文直播效率</p>
    <div class="form_box">
        <div>
            <span>主办单位</span>
            <el-input style="width: 426px;" maxlength="50" show-word-limit v-model="formData.livecompany" placeholder="请输入主办单位，不超过50字"></el-input>
        </div>
        <div>
            <span>时间地点</span>
            <el-input style="width: 426px;" maxlength="50" show-word-limit v-model="formData.timeplace" placeholder="请输入时间地点，不超过50字"></el-input>
        </div>
        <div class="spokesman_box">
            <span>发言人</span>
            <!-- <el-input style="width: 426px;" v-model="formData.dgusername" placeholder=""></el-input> -->
            <el-select style="width: 926px;" v-model="dgusername" multiple filterable allow-create default-first-option size="small" placeholder="输入发言人（可多个）">
                <el-option v-for="item in dguserList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
        </div>
        <div>
            <span></span>
            <el-button style="width: 96px; margin-top: 50px;" @click="saveSponsorInfo" type="primary">保存</el-button>
        </div>
    </div>
</div>
</template>

<script>
import {updateLiveHostInfo} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'SponsorInfo',
    data() {
        return {
            formData: {
                livecompany: '', // 主办单位
                timeplace: '', // 时间地点
                dgusername: '' // 发言人
            },
            dgusername: ['主持人'], // 发言人
            dguserList: ['主持人'] //主持人列表
        }
    },
    mounted() {},
    methods: {
        setFormData(data) {
            this.formData.livecompany = data.livecompany
            this.formData.timeplace = data.timeplace
            this.formData.dgusername = data.dgusername
            if (data.dgusername !== '') {
                this.dgusername = data.dgusername.split(',')
            }
        },
        saveSponsorInfo() {
            this.formData.dgusername = this.dgusername.join(',')
            // console.log(this.formData)
            // console.log(this.dgusername)
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.id
            }
            updateLiveHostInfo({
                data: Object.assign({}, params, this.formData),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('保存成功')
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.SponsorInfo {
    font-family:PingFangSC-Regular,PingFang SC;
    .tips_text {
        line-height: 48px;
        background-color: #F5F7FA;
        margin-bottom: 20px;
        padding-left: 20px;
    }
    .form_box {
        &>div {
            height: auto;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            &>span {
                width: 82px;
                color:rgba(48,49,51,1);
            }
        }
        // .spokesman_box {
        //     align-items: flex-start;
        //     background-color: pink;
        //     // height: 200px;
        //     &>span {
        //         margin-top: 10px;
        //     }
        //     .el-select {
        //         height: 200px;
        //     }
        //     // .el-select__input {
        //     //     height: 80px;
        //     // }
        // }
    }
}
</style>